<div class="flex flex-col h-full">
  <p-table
    [value]="konverteringer.value() || []"
    showGridlines
    stripedRows
    [scrollable]="true"
    scrollHeight="flex"
    [loading]="konverteringer.isLoading()"
    class="flex-1 overflow-hidden p-datatable-sm mt-4">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="navn">
          Navn
          <p-sortIcon field="navn" />
        </th>
        <th pSortableColumn="fraHreg">
          Fra Hreg
          <p-sortIcon field="fraHreg" />
        </th>
        <th pSortableColumn="tilHreg">
          Til Hreg
          <p-sortIcon field="tilHreg" />
        </th>
        <th pSortableColumn="kdag" style="width: 150px">
          K-dag
          <p-sortIcon field="kdag" />
        </th>
      </tr>
    </ng-template>
    <ng-template
      [appTableRow]="konverteringer.value() || []"
      pTemplate="body"
      let-konvertering>
      <tr
        [routerLink]="['/konvertering']"
        [queryParams]="{ id: konvertering.id }"
        class="cursor-pointer">
        <td>{{ konvertering.navn }}</td>
        <td>{{ konvertering.fraHreg }}</td>
        <td>{{ konvertering.tilHreg }}</td>
        <td class="numbers">
          {{ konvertering.kDag | date: 'dd-MM-yyyy' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
